import { useEffect } from "react"

import WorldMapImage from "@/assets/images/map.png"

interface IProps {
  children: React.ReactNode
}

const AuthLayout = ({ children }: IProps) => {
  useEffect(() => {
    const root = document.getElementById("root")
    const html = document.documentElement
    const body = document.body

    const previousHtmlOverflow = html.style.overflow
    const previousBodyOverflow = body.style.overflow
    const previousRootHeight = root?.style.height ?? ""
    const previousRootMinHeight = root?.style.minHeight ?? ""
    const previousRootOverflow = root?.style.overflow ?? ""
    const previousRootWidth = root?.style.width ?? ""
    const previousHtmlOverflowX = html.style.overflowX
    const previousBodyOverflowX = body.style.overflowX

    html.style.overflow = "auto"
    html.style.overflowX = "hidden"
    body.style.overflow = "auto"
    body.style.overflowX = "hidden"

    if (root) {
      root.style.width = "100%"
      root.style.height = "auto"
      root.style.minHeight = "100svh"
      root.style.overflow = "visible"
    }

    return () => {
      html.style.overflow = previousHtmlOverflow
      html.style.overflowX = previousHtmlOverflowX
      body.style.overflow = previousBodyOverflow
      body.style.overflowX = previousBodyOverflowX

      if (root) {
        root.style.width = previousRootWidth
        root.style.height = previousRootHeight
        root.style.minHeight = previousRootMinHeight
        root.style.overflow = previousRootOverflow
      }
    }
  }, [])

  return (
    <div className="flex min-h-svh overflow-x-hidden bg-white">
      {/* Left Content Section */}
      <div className="flex min-h-0 min-w-0 flex-1 overflow-x-hidden">
        {children}
      </div>

      {/* Right Hero Section */}
      <div
        className="hidden xl:flex min-h-svh w-auto aspect-[565/832] shrink-0 self-stretch"
        style={{
          backgroundImage: `url(${WorldMapImage.src})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      />
    </div>
  )
}

export default AuthLayout
